import * as lodash from './lodash';
var enable1px = false;
export function enableLine1pxOptimize() {
    enable1px = true;
}
export function pixelOptimize(v) {
    return Math.floor(v) + 0.5;
}
export default function line1px(option) {
    if (!enable1px) {
        return;
    }
    var min = 1e-4;
    if (Math.abs(option.x1 - option.x2) < min) {
        option.x1 = option.x2 = pixelOptimize(option.x1);
    }
    if (Math.abs(option.y1 - option.y2) < min) {
        option.y1 = option.y2 = pixelOptimize(option.y1);
    }
    return option;
}
export function rect1px(option) {
    if (option) {
        if (lodash.isNumber(option.x) && lodash.isNumber(option.y)) {
            var x = option.x, y = option.y, width = option.width, height = option.height;
            option.x = pixelOptimize(option.x);
            option.y = pixelOptimize(option.y);
            var right = Math.round(x + width) + 0.5;
            var bottom = Math.round(y + height) + 0.5;
            if (option.width > 0 && option.height > 0) {
                option.width = right - option.x;
                option.height = bottom - option.y;
            }
        }
    }
    return option;
}
